import { useApplicationStore as A, IncomeCollectionType as oe, useProviderStore as E, useTermsService as ot, InjectionKeys as pe, useApplicationService as te, extractProviderKey as ue, DynamicProviderKey as Re, getProviderModule as be, useLocaleStore as de, useSessionStore as $, useFinishFlow as st, useGeneralRouteMappings as Ne, toRouteLocation as Te, fillPath as it, useSwitchProvider as Me, useRefreshProviderStipulationStatus as at, useStipulationService as ut, useLogger as V, useErrorStore as De, useAppI18n as lt, useFlowService as Oe, pendingResponse as Ee, prequalifiedResponse as se, query as G, responseByProvider as ie, responseByProviderKey as ct, extractOptionalProviderKey as pt, approvedResponse as dt, enumToPath as ft, usePublishEvent as vt, useMemoize as Z, useMerchantStore as re, fullDaysBetween as yt, localDate as mt, usePaymentPlanService as ht, useCurrentApplyResponse as gt, useNavigationStore as wt } from "@versatile-credit-apply/sdk";
import { useAcceptOffer as no, useApplicationService as oo, useFlowService as so, useLogger as io, useMerchantLegalName as ao, useMerchantName as uo, usePaymentPlanService as lo, useStipulationService as co, useSubmitApplication as po, useTestCaseService as fo, useValidationService as vo } from "@versatile-credit-apply/sdk";
import { ApplicantType as O, ApplyResponseCode as S, useOmniApplyApiState as fe, ProviderApplyOperation as X, StipulationStatus as Pt, useOmniApplyApiClient as ve, ApiException as St, HEADER_SESSION_ID as At, VerifyCodeStatus as Ct } from "@versatile-credit-apply/omni-apply-client";
import { useOmniApplyApiClient as mo } from "@versatile-credit-apply/omni-apply-client";
import { computed as i, toValue as F, inject as W, onMounted as z, provide as ne, unref as ee, ref as g, nextTick as x, watch as k, onUnmounted as ye, markRaw as Ke, toRef as Fe, watchEffect as It } from "vue";
import { useRoute as j, useRouter as L } from "vue-router";
import { sortBy as le, keyBy as Rt, isNaN as Et } from "lodash-es";
import { useIntervalFn as Kt, computedAsync as $e } from "@vueuse/core";
import { useI18n as xe } from "vue-i18n";
import _t from "mitt";
class _r {
  _field;
  _value;
  constructor(t, r) {
    this._field = t, this._value = r;
  }
  get id() {
    return this._field.id;
  }
  get path() {
    return this._field.path;
  }
  get type() {
    return this._field.type;
  }
  get rules() {
    return this._field.rules;
  }
  get field() {
    return this._field;
  }
  get value() {
    return this._value;
  }
}
const Y = () => {
  const e = A();
  return i(() => e.application);
}, bt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.grossAnnualCents : e === O.JOINT ? t.value?.joint?.income?.grossAnnualCents : void 0);
}, Nt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.grossMonthlyCents : e === O.JOINT ? t.value?.joint?.income?.grossMonthlyCents : void 0);
}, Tt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.netMonthlyCents : e === O.JOINT ? t.value?.joint?.income?.netMonthlyCents : void 0);
}, Mt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.netAnnualCents : e === O.JOINT ? t.value?.joint?.income?.netAnnualCents : void 0);
}, br = (e, t) => {
  let r;
  switch (t) {
    case oe.GROSS_MONTHLY:
      r = Nt(e);
      break;
    case oe.NET_MONTHLY:
      r = Tt(e);
      break;
    case oe.NET_ANNUAL:
      r = Mt(e);
      break;
    default:
      r = bt(e);
  }
  return r;
}, Nr = (e, t) => {
  const r = A();
  return i(() => {
    const n = F(e), o = r.application, s = n === O.PRIMARY ? o?.primary : o?.joint;
    switch (t) {
      case "first":
        return s?.firstName ?? "";
      case "last":
        return s?.lastName ?? "";
      default:
        return `${s?.firstName ?? ""} ${s?.lastName ?? ""}`.trim();
    }
  });
}, Dt = (e) => {
  const t = A();
  return i(() => t.getApplicationValue(F(e)));
}, me = () => {
  const e = A();
  return i(() => e.applyMode);
}, ke = () => {
  const e = A(), t = j();
  return i(
    () => t.params.applyStage ?? e.applyStage ?? e.applyMode
  );
}, Tr = () => ze(
  (e) => e.responseCode === S.APPROVED
), ze = (e = () => !0) => {
  const t = E();
  return i(() => t.applyResponses.filter(e));
}, he = (e) => {
  const t = W(e);
  if (!t)
    throw new Error(`Unable to inject: ${e.description}, this is fatal!`);
  return t;
}, Le = ot, Mr = () => he(pe.AccountServiceKey), Dr = () => he(pe.GoogleTagManagerKey), Ue = () => he(pe.VerificationServiceKey), Or = (e, t, r) => {
  const n = Le(), o = t ?? e, s = {
    contentType: e,
    data: n.getApplyTermsUrl(e, r)
  }, a = {
    contentType: o,
    data: n.getApplyTermsUrl(o, r)
  };
  return {
    content: s,
    downloadableContent: a,
    printableContent: a
  };
}, We = () => {
  const e = E();
  return i(() => e.cascade || []);
}, Fr = (e) => {
  const t = te();
  z(async () => {
    await t.completeApplication(), e.onComplete && e.onComplete();
  });
}, Ot = () => {
  const e = E();
  return i(() => {
    const t = e.currentProviderKey;
    if (!t)
      throw Error("Provider is not set in the store!");
    return t;
  });
}, $r = () => {
  const e = E();
  return i(() => {
    const t = e.currentProviderConfig;
    if (!t)
      throw Error("Config for current provider is not set in the store!");
    return t;
  });
}, Be = /* @__PURE__ */ Symbol("currentProvider"), xr = (e) => {
  ne(Be, e);
}, N = () => {
  const e = E(), t = W(Be, null);
  return i(() => ee(t) ?? e.currentProviderKey);
}, Ve = (e) => {
  const t = e || N();
  return i(() => {
    const r = t.value;
    return r ? ue(r) : null;
  });
};
function Ft() {
  const e = N(), t = E();
  return i(() => {
    if (!e.value)
      return [];
    const r = t.cascade, n = new Re(e.value ?? "").providerKey, o = r.findIndex(
      (p) => new Re(p.providerKey).providerKey === n
    );
    if (o < 0)
      return [];
    const s = r[o];
    let a = o, u = o;
    for (let p = o - 1; p >= 0; p--) {
      const l = r[p];
      if (l?.cascadeGroup && l.cascadeGroup === s?.cascadeGroup)
        a = p;
      else
        break;
    }
    for (let p = o + 1; p < r.length; p++) {
      const l = r[p];
      if (l?.cascadeGroup && l.cascadeGroup === s?.cascadeGroup)
        u = p;
      else if (l?.autoSubmit)
        u = p;
      else
        break;
    }
    return r.slice(a, u + 1);
  });
}
function kr() {
  const e = Ft();
  return i(() => e.value.map((t) => be(t.providerKey)));
}
const $t = /\/:[a-zA-Z0-9-_]+/g, xt = /\//g, kt = (e, t, r) => `/providers/:providerKey(${t}[^/]*)/${e}${r}`, zr = (e) => ({
  defineRoute: (t) => {
    const r = t.path, n = t.meta ?? {};
    n.providerKey = e;
    const o = r.substring(1).replace($t, "").replace(xt, "."), s = `${e}.${t.name ?? o}`, a = t.experienceType, u = a ? encodeURIComponent(a) : ":experienceType", p = kt(
      u,
      e,
      r
    );
    t.inherit && (n.extends = typeof t.inherit == "boolean" ? o : t.inherit);
    const l = t.component;
    if (l)
      return {
        meta: n,
        name: s,
        path: p,
        component: l,
        children: t.children,
        beforeEnter: t.beforeEnter,
        props: t.props
      };
    const d = t.redirect;
    if (d)
      return {
        name: s,
        path: p,
        redirect: d
      };
    const v = t.children;
    if (v)
      return {
        name: s,
        path: p,
        children: v
      };
    throw new Error(`Invalid route definition [${t.path}]`);
  }
}), Lr = () => {
  const e = E();
  return i(() => e.cascade?.length > 1);
}, B = () => {
  const e = de();
  return i(() => e.experienceType ?? "in_store");
}, Ur = () => {
  const e = B();
  return i(() => e.value === "at_home");
}, Wr = () => {
  const e = B();
  return i(() => e.value === "in_store");
}, Br = () => {
  const e = $();
  return i(() => e.isActive || !1);
}, zt = (e) => i(() => e.timedout), Lt = (e) => i(() => e.timeout), Vr = () => {
  const e = st(), t = L(), r = j(), n = Ne(), o = $(), s = N(), a = fe(), u = i(() => a.callInProgress), p = zt(o), l = Lt(o), d = g(!1), v = async (T) => {
    const m = r.meta?.screenId, P = {
      providerKey: s.value ?? void 0,
      screenId: m
    };
    d.value = !1;
    const { transition: y } = await e(
      T ? "timeout" : "canceled",
      P
    );
    await x();
    const _ = {
      finish: "false"
    };
    y?.destination && (_.destination = y.destination), await t.replace(
      Te({
        to: n.session_timeout,
        query: _
      })
    );
  }, w = () => {
    u.value || (d.value = !0);
  }, I = g(), K = g();
  k(l, () => C(!1)), k(u, (T) => {
    T || x().then(() => C(!1));
  }), k(p, (T) => {
    T && x().then(() => v(!1));
  });
  const C = (T = !1) => {
    I.value && clearTimeout(I.value), K.value && clearTimeout(K.value), T ? v(!1) : (l.value.timeoutAfterMillis && (I.value = window.setTimeout(
      () => v(!0),
      l.value.timeoutAfterMillis
    )), l.value.warnAfterMillis && (K.value = window.setTimeout(
      w,
      l.value.warnAfterMillis
    ), d.value = !1));
  };
  return z(() => C(!1)), {
    reset: C,
    displayWarning: i(() => d.value || !1)
  };
}, Ut = () => {
  const e = $();
  return i(() => e.sessionId ?? null);
}, Gr = () => {
  const e = $();
  return i(() => e.flowSessionId ?? null);
}, Ge = (e, t, r) => {
  const n = r?.params?.experienceType ?? "in_store", o = encodeURIComponent(n);
  return `/providers/${encodeURIComponent(e)}/${o}${t}`;
}, qe = (e, t, r) => {
  const n = {
    path: it(
      Ge(e, t, r),
      r?.params
    )
  };
  return r?.query && (n.query = r.query), r?.replace && (n.replace = r.replace), n;
}, ge = (e, t, r, n) => {
  const o = qe(t, r, n);
  return n?.replace ? e.replace(o) : e.push(o);
}, qr = (e) => {
  const t = B(), r = N(), n = i(
    () => F(e?.experienceType) ?? t.value
  ), o = i(
    () => F(e?.providerKey) ?? r.value
  ), s = L();
  return (a, u) => {
    const p = {
      ...u?.params,
      experienceType: n.value
    }, l = { ...u, ...p };
    return ge(s, o.value, a, l);
  };
}, Wt = (e) => i(() => {
  const t = F(e);
  return t ? be(t) : void 0;
}), Jr = () => {
  const e = N(), t = me(), r = g(e.value), n = E(), o = Me();
  return k(r, (a) => {
    a && n.switchProvider(a);
  }), {
    commit: async () => {
      const a = r.value;
      let u = t.value;
      a && u && (Wt(a).value?.switchToFullApplyAfterPrequal && (u = "full"), await o({
        providerKey: a,
        applyMode: u
      }));
    }
  };
}, Bt = () => {
  const e = E();
  return i(() => e.primary);
}, Hr = () => {
  const e = ke(), t = Bt(), r = N();
  return i(() => e.value === "offer" ? !1 : r.value === t.value?.providerKey);
}, jr = () => {
  const e = A();
  return i(() => e.application?.jointEnabled === !0);
}, Yr = () => {
  const e = A();
  return i(() => e.jointSelectionEnabled ?? !0);
}, Vt = (e, t, r, n, o) => ge(
  e,
  t,
  `/apply/${r}${n}`,
  o
), Qr = (e, t, r) => {
  const n = r?.params?.applyStage ?? "full";
  return Ge(
    e,
    `/apply/${n}${t}`,
    r
  );
}, Gt = (e) => {
  const t = e?.applyStage ?? ke(), r = e?.providerKey ?? N(), n = L();
  return (o, s) => {
    const a = ee(t) ?? "full", u = ee(r);
    if (!u)
      throw new Error("Unable to resolve active provider key for navigation");
    return Vt(n, u, a, o, s);
  };
}, qt = (e, t) => e ? X.isSoftHit(e) : t !== "full", Je = (e, t = !1) => {
  let r = e?.params?.applyStage;
  !r && S.isAnyPreApproval(e.responseCode) && (r = "offer"), !r && e?.operation && (r = Jt(e.operation)), r || (r = "full");
  let n = `/apply/${encodeURIComponent(r)}`;
  return n += e.resume ? "/resume/responses" : "/responses", t ? n += `/${encodeURIComponent(e.responseCode)}` : e.responseCode === S.PENDING ? n += qt(e.operation, r) ? "/pending_offer" : "/pending_full" : n += `/${encodeURIComponent(e.responseCode)}`, n;
}, Zr = (e) => qe(
  e.providerKey,
  Je(e, !0)
), Jt = (e) => He(e), He = (e) => {
  switch (e) {
    case X.PREQUALIFY:
      return "prequalify";
    case X.PRESCREEN:
      return "prescreen";
    default:
      return "full";
  }
}, Xr = (e) => e === S.PENDING, Ht = (e, t, r) => ge(
  e,
  t.providerKey,
  Je({
    ...r,
    responseCode: t.responseCode,
    operation: t.operation
  }),
  r
), en = () => {
  const e = L(), t = B(), r = me();
  return (n, o) => {
    const s = o?.params?.applyMode ?? He(n.operation) ?? r?.value ?? "full", a = o?.params?.experienceType ?? t.value ?? "in_store", u = { ...o?.params, applyMode: s, experienceType: a }, p = { ...o, params: u };
    return Ht(e, n, p);
  };
}, tn = () => {
  const e = A();
  return i(() => e.originalApplication);
}, rn = () => {
  const e = te(), t = Gt();
  z(async () => {
    const r = await e.patchApplication();
    if (r.provider && (r.provider.responseCode === S.PREQUALIFIED || r.provider.responseCode === S.APPROVED))
      await t("/patchSuccess");
    else if (r.provider && (r.provider.responseCode === S.DECLINED || r.provider.responseCode === S.PENDING))
      await t("/responses/" + r.provider.responseCode);
    else
      throw new Error("Unhandled patch response!");
  });
}, nn = (e) => {
  const t = E(), r = A(), n = i(() => e.value ? t.findOverrides(e.value) || {} : {}), o = i(() => {
    const u = n.value?.downPaymentAmountCents;
    return u !== void 0 ? u : r.application?.downPaymentAmountCents;
  });
  return {
    amount: o,
    setAmount: (u) => {
      e.value && t.addOverrides(e.value, {
        ...n.value,
        downPaymentAmountCents: u
      });
    },
    commit: () => r.setApplicationValue("downPaymentAmountCents", o.value)
  };
}, jt = (e) => {
  const t = E();
  return i(() => {
    const r = t.preauthResponses, n = (o) => e !== !0 ? !0 : o.responseCode === S.PREAPPROVED || o.responseCode === S.PREQUALIFIED;
    return le(r.filter(n), ["approvedAmountCents"]).reverse();
  });
}, on = () => {
  const e = A();
  return i(() => e.primaryProviderApplyMode);
}, sn = () => {
  const e = A(), t = E(), r = N();
  return i(() => {
    const n = e.previousResponses, o = Rt(
      t.cascade,
      "providerKey"
    );
    let s = je(
      n,
      r.value
    );
    const a = Zt(
      n,
      r.value
    );
    if (s < 0) {
      if (a < 0)
        return [];
      s = a;
    }
    const u = [];
    if (s !== a) {
      const d = n[s];
      d && u.push(d);
    }
    const p = n[s], l = o[p?.provider?.providerKey ?? ""];
    for (let d = s + 1; d < n.length; d++) {
      const v = n[d];
      if (v) {
        const w = o[v.provider?.providerKey ?? ""];
        if (d === s)
          continue;
        if (w?.cascadeGroup !== l?.cascadeGroup)
          break;
        u.push(v);
      }
    }
    return u.filter((d) => {
      const v = d.provider;
      if (!v || v.providerKey == r.value)
        return !1;
      switch (d.provider?.responseCode) {
        case S.DECLINED:
        case S.NOOFFER:
          return !0;
        case S.PENDING:
          return X.isSoftHit(v.operation);
        default:
          return !1;
      }
    });
  });
}, an = () => {
  const e = A(), t = N();
  return i(() => {
    const r = e.previousResponses, n = je(
      r,
      t.value
    );
    return n < 0 ? null : r[n];
  });
}, je = (e, t) => {
  for (let r = e.length - 1; r >= 0; r--) {
    const n = e[r];
    if (n && Yt(n, t))
      return r;
  }
  return -1;
}, Yt = (e, t) => !e.provider || e.provider.providerKey === t ? !1 : !Qt(e), Qt = (e) => e.provider?.autoSubmit ?? !1;
function Zt(e, t) {
  return t ? e.findIndex(
    (r) => r.provider?.providerKey === t
  ) : -1;
}
const un = (e) => {
  const t = A(), r = E(), n = at(), o = ut(), s = V("useRefreshPendingStipulation"), a = () => {
    const l = F(e), v = ("providerKey" in l ? r.findStipulations(l.providerKey) : t.stipulations).filter((w) => w.type === l.type).filter((w) => w.status === Pt.PENDING);
    return v.length ? v[v.length - 1] ?? null : null;
  }, p = Kt(() => {
    const l = a(), d = F(e);
    l && "providerKey" in d ? n(d.providerKey, l).catch(
      (v) => s.error("Failure trying to refresh stipulation", v)
    ) : l ? o.refreshSessionStipulationStatus(l).catch((v) => s.error("Failure trying to refresh stipulation", v)) : p.pause();
  }, 2500);
  return i(() => a() != null);
}, ln = () => {
  const e = A();
  return i(() => e.stipulations);
}, cn = () => {
  const e = We().value, t = e[0];
  return i(
    () => e.some(
      (r) => r.cascadeGroup !== t?.cascadeGroup && r.autoSubmit
    )
  );
}, pn = (e) => {
  const t = ve(), r = Ve(), n = e ?? r.value;
  return (o) => n ? t.validateBankCard(n, o) : Promise.resolve(void 0);
}, Xt = () => {
  const e = A();
  return (t, r) => {
    e.setApplicationValue(t, r);
  };
}, dn = () => {
  const e = A();
  return (t) => {
    e.setApplicationValues(t);
  };
}, er = ["employed", "self_employed", "other"], fn = (e) => {
  const t = Dt(
    () => `${e.value}.income.type`
  );
  return i(() => {
    const r = t.value;
    return r ? er.includes(r) : !1;
  });
}, vn = () => g(), Ye = /* @__PURE__ */ Symbol("page-title"), yn = (e) => {
  ne(Ye, e);
}, tr = () => {
  const e = W(Ye);
  return (t) => {
    e && (e.value = t);
  };
}, mn = (e) => {
  const t = xe(), r = tr();
  e && typeof e != "string" && k(e, (s) => r(t.t(s || "page_title")), {
    immediate: !0
  }), z(() => {
    (!e || typeof e == "string") && r(t.t(e || "page_title"));
  });
};
function hn(e) {
  const t = rr(e);
  return [t.call, t.processing, t.error];
}
function rr(e) {
  const t = g(!1), r = g();
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    call: async (...n) => {
      t.value = !0;
      try {
        return await e(...n);
      } catch (o) {
        throw r.value = o, o;
      } finally {
        t.value = !1;
      }
    },
    error: i(() => r.value),
    processing: i(() => t.value)
  };
}
const gn = () => {
  const e = B();
  return i(() => e.value !== "in_store");
}, wn = (e, t) => {
  z(() => {
    window.addEventListener(e, t);
  }), ye(() => {
    window.removeEventListener(e, t);
  });
}, nr = () => {
  const e = $(), t = fe();
  return i(() => e.environment ?? t.environment);
}, or = () => {
  const e = nr();
  return i(() => e.value === "prod");
}, Pn = () => {
  const e = or();
  return i(() => !e.value);
}, Sn = () => {
  const e = De();
  return i(() => {
    const t = e.error;
    return t instanceof St ? t : void 0;
  });
};
function An(e) {
  const t = lt(), r = De(), n = B();
  return i(() => {
    const o = e?.error?.value ?? r.error;
    if (!o)
      return {
        instructionsKey: q(n.value),
        messageKey: J(),
        headingKey: H()
      };
    if (typeof o == "string")
      return {
        instructionsKey: q(n.value),
        messageKey: J(),
        headingKey: H(),
        details: o
      };
    if (o instanceof Error)
      return {
        instructionsKey: q(n.value),
        messageKey: J(),
        headingKey: H(),
        details: o.message
      };
    if (typeof o == "object") {
      const s = o, a = s._error?.cloudRequestId, u = s._error?.message ?? s.message ?? "", p = s._error?.code ?? s.code, l = s._statusCode;
      let d = p;
      return s._statusCode && (d ? d = `(${s._statusCode}) ${d}` : d = s._statusCode), {
        ...sr(t, n.value, p, l),
        code: d,
        trackingId: a,
        details: u
      };
    }
    return {
      instructionsKey: q(n.value),
      messageKey: J(),
      headingKey: H()
    };
  });
}
function ce(e, t) {
  return `${e}.${t}`;
}
function sr(e, t, r, n) {
  const o = r ?? "general", s = n ?? 500;
  let a, u, p;
  if (o !== "general") {
    const l = `errors.${o}.message.user`, d = ce(
      `errors.${o}.instructions`,
      t
    ), v = `errors.${o}.heading`;
    u = e.te(d) ? d : void 0, a = e.te(l) ? l : void 0, p = e.te(v) ? v : void 0;
  }
  if (!u) {
    const l = ce(
      `errors.${s}.instructions`,
      t
    );
    u = e.te(l) ? l : q(t);
  }
  if (!a) {
    const l = `errors.${s}.message`;
    a = e.te(l) ? l : J();
  }
  if (!p) {
    const l = `errors.${s}.heading`;
    p = e.te(l) ? l : H();
  }
  return {
    instructionsKey: u,
    messageKey: a,
    headingKey: p
  };
}
function q(e) {
  return ce("errors.general.instructions", e);
}
function J() {
  return "errors.general.message.user";
}
function H() {
  return "errors.general.heading";
}
const we = () => {
  const e = $();
  return i(() => e.flowType);
}, Cn = () => {
  const e = L(), t = j(), r = we(), n = Ne(), o = i(() => t.meta?.screenId);
  return async (s) => {
    const a = r.value;
    if (s === "timeout")
      throw new Error(
        "Flow timeout is not supported here. Use SessionService instead."
      );
    await e.push(
      Te({
        to: n.exit,
        query: {
          flowType: a,
          screenId: o.value,
          outcome: s
        }
      })
    );
  };
};
function ir() {
  const e = $();
  return i(() => e.providerResume?.requestedProviderKey);
}
const In = (e) => {
  const t = g(!1), r = V("use-resume-application.ts"), n = A(), o = E(), s = $(), a = Oe(), u = Me(), p = te(), l = (c) => (s.providerResume?.replayResponseCodes ?? []).includes(c.responseCode), d = ze(), v = i(
    () => d.value.filter((c) => Ee(c))
  ), w = jt(), I = i(
    () => w.value.filter(
      (c) => se(c)
    )
  ), K = ir(), C = We(), T = () => {
    const c = le(
      d.value.filter(l),
      ["applicationDateTime"]
    );
    if (c.length)
      return c[0];
    const h = le(
      w.value.filter(l),
      ["applicationDateTime"]
    );
    if (h.length)
      return h[0];
  }, m = async (c) => {
    const h = Ie(c);
    if (h)
      return await h;
    if (rt(c.providerKey))
      return D();
    r.info("A full apply is present in the session, not resuming..."), await f();
  }, P = async (c) => {
    r.info(
      "Resuming a full apply in pending state for:",
      c.providerKey
    ), await p.hydrateProvider(c), await u({
      providerKey: c.providerKey,
      applyMode: "full"
    }), await e.handlePendingProvider(c);
  }, y = async () => {
    for (const b of I.value)
      await p.hydrateProvider(b);
    let c;
    if (K.value && (c = G(C, (b) => {
      const M = G(
        I,
        ie(b)
      );
      return M && M.providerKey === K.value ? se(M) : !1;
    })), c || (c = G(C, (b) => {
      const M = G(
        I,
        ie(b)
      );
      return M ? se(M) : !1;
    })), !c)
      throw new Error("Cannot resume, no provider found!");
    const h = G(
      I,
      ie(c)
    );
    if (!h)
      throw new Error("Cannot resume, no response found!");
    await Q(h, {
      // we disable hydration here because we've already done it above.
      hydrate: !1
    }), r.info(
      "Resuming multiple offer flow starting with:",
      c.providerKey
    ), await e.handleMultipleOffers({
      provider: h,
      requestedProviderKey: K.value
    });
  }, _ = async () => {
    const c = I.value.first();
    await Q(c), r.info("Resuming prequalification of", c.providerKey), await e.handleSingleOffer(c);
  }, D = async () => {
    const c = d.value.first();
    await Q(c), r.info("Resuming full apply for", c.providerKey), await e.handleSingleOffer(c);
  }, f = async () => {
    const c = await a.restartFlow();
    await x(), await e.handleFlowRestart(c);
  }, R = (c, h, b) => {
    for (const M of h)
      if (c.includes(M))
        return M;
    return b;
  }, U = (c) => {
    const h = ct(c.providerKey), b = I.value.find(h);
    if (b)
      return b.responseCode === S.PREAPPROVED ? "prescreen" : "prequalify";
    const M = o.findProviderConfig(c.providerKey)?.applyModes ?? [];
    return w.value.find(h) ? R(
      M,
      ["prequalify", "prescreen"],
      "prequalify"
    ) : R(
      M,
      ["full", "prequalify", "prescreen"],
      "full"
    );
  }, Q = async (c, h) => {
    (h?.hydrate ?? !0) && await p.hydrateProvider(c), n.switchApplyMode(U(c)), o.switchProvider(c.providerKey), await x();
  }, rt = (c) => pt(c) === "aff_standard", nt = async (c, h) => (await Q(c), h(c)), Ie = (c) => {
    if (!c)
      return;
    const h = e.handleReplayDecision;
    if (h && l(c))
      return nt(c, h);
  };
  return z(async () => {
    r.info("Attempting application resume");
    const c = d.value.find(dt);
    if (c)
      return await m(c);
    const h = v.value.find(Ee);
    if (h)
      return await P(h);
    if (I.value.length > 1)
      return await y();
    if (I.value.length === 1)
      return _();
    const b = Ie(T());
    if (b)
      return await b;
    r.warn(
      "Un-resumable application data, restarting the application from the top."
    ), await f();
  }), i(() => t.value);
}, Qe = {
  routeParamNames: {
    entityKey: "entityKey",
    token: "token"
  }
}, Rn = (e = Qe) => {
  const t = L();
  return ar(async (r) => {
    await x();
    const n = "/" + ft(r.flowType), o = r.providerKey ? `/providers/${encodeURIComponent(r.providerKey)}` : "", s = r.resume ? "/resume" : "/start", a = `${o}${n}${s}`;
    await t.push(a);
  }, e);
}, ar = (e, t = Qe) => {
  const r = V("use-start-flow.ts"), n = j(), o = A(), s = Oe(), a = vt(), u = Z(
    (m) => s.startFlowWithToken(m)
  ), p = Z(
    (m) => s.startFlowWithEntityKey(m)
  ), l = Z(
    () => s.startFlowWithDefaultEntityKey()
  ), d = Z(
    (m) => s.reevaluateCascade(m)
  ), v = async (m) => {
    r.info("Starting flow with token:", m);
    const P = await u(m);
    return C(P);
  }, w = async (m) => {
    r.info("Starting flow with entity key:", m);
    const P = await p(m);
    return C(P);
  }, I = async () => {
    r.info("Starting flow with default entity key");
    const m = await l();
    return C(m);
  }, K = async () => {
    r.info("Reevaluating Cascade");
    const m = await d({
      launchConfig: {
        prefill: {
          primaryApplicant: {
            address: {
              state: o.application?.primary?.homeAddress?.state,
              zipCode: o.application?.primary?.homeAddress?.zipCode
            }
          }
        }
      }
    });
    return C(m, !0);
  }, C = async (m, P = !1) => {
    await x(), m.flowType === "apply" && !P && a({
      type: "start",
      flow: "application"
    }), await e(m);
  }, T = async () => {
    const m = n.params[t.routeParamNames.token], P = n.params[t.routeParamNames.entityKey], y = !!n.query.reevaluate;
    try {
      m ? await v(m) : P ? await w(P) : y ? await K() : await I();
    } catch (_) {
      throw r.error("Failed to start application", _), _;
    }
  };
  z(() => T());
}, En = () => {
  const e = $();
  return i(() => e.testCases);
}, Pe = (e) => {
  const t = de();
  return i(() => F(e) ?? t.group);
};
class ur {
  _fields;
  _parent;
  constructor(t) {
    this._fields = g(/* @__PURE__ */ new Map()), this._parent = t;
  }
  get fields() {
    return [...this._fields.value.values()];
  }
  get count() {
    return this._fields.value.size;
  }
  attach(t) {
    t.id && (this._fields.value.set(t.id, t), this._parent?.attach(t), this.updateRef());
  }
  detach(t) {
    t && (this._fields.value.delete(t), this._parent?.detach(t), this.updateRef());
  }
  isAttached(t) {
    return this._fields.value.has(t);
  }
  updateRef() {
    this._fields.value = new Map(this._fields.value);
  }
}
class Ze {
  wizardById = {};
  layoutById = {};
  sectionById = {};
  constructor(t) {
    t.layouts.forEach((r) => {
      this.layoutById[r.id] = r;
    }), t.sections.forEach((r) => {
      this.sectionById[r.id] = r;
    }), t.wizards.forEach((r) => {
      this.wizardById[r.id] = r;
    });
  }
  findLayoutById(t, r) {
    return this.layoutById[r] ?? null;
  }
  findSectionById(t, r) {
    return this.sectionById[r];
  }
  findWizardById(t, r) {
    return this.wizardById[r];
  }
  static fromConfig(t) {
    return new Ze(t);
  }
}
const ae = "default", _e = "default", lr = "_first", cr = "_last";
class pr {
  id = g("id");
  context;
  fieldController;
  repository;
  stepId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  overrideSectionProps;
  _stepNumber = i(() => {
    const t = this.stepId.value;
    if (typeof t == "number")
      return t;
    if (t === lr)
      return 1;
    const r = Number(t);
    if (!Et(r))
      return r;
    const n = this.wizard.value?.steps ?? [];
    if (t === cr)
      return n.length || 1;
    const o = n.findIndex(
      (s) => s.id === t
    );
    return o < 1 ? 1 : o + 1;
  });
  wizard = i(() => {
    let t = this.repository.findWizardById(
      this.context.value,
      this.id.value
    );
    return !t && this.id.value !== _e && (t = this.repository.findWizardById(
      this.context.value,
      _e
    )), t ? this.materializeWizard(this.context.value, t) : null;
  });
  constructor(t, r) {
    this.context = r.context, this.fieldController = t, this.id = r.id, this.stepId = r.stepId, this.overrideSectionProps = r.sectionProps ?? g({}), this.repository = r.repository;
  }
  get fieldCount() {
    return this.fieldController.count;
  }
  get fields() {
    return this.fieldController.fields;
  }
  get stepNumber() {
    return this._stepNumber.value;
  }
  get previousStepNumber() {
    return this.stepNumber <= 1 ? null : this.wizard.value?.layout?.stepped ? this.stepNumber - 1 : 1;
  }
  get nextStepNumber() {
    const t = this.wizard.value;
    if (!t?.layout?.stepped)
      return null;
    const r = t.steps;
    return this.stepNumber >= r.length ? null : this.stepNumber + 1;
  }
  materializeWizard(t, r) {
    return {
      id: r.id,
      layout: this.materializeLayout(t, r),
      steps: this.steps(t, r).map((n) => this.materializeStep(t, r.id, n))
    };
  }
  materializeStep(t, r, n) {
    return {
      id: n.id,
      sections: n.sections.map((o) => this.materializeSection(t, r, n.id, o))
    };
  }
  materializeSection(t, r, n, o) {
    const s = this.repository.findSectionById(t, o);
    if (!s)
      throw new Error(
        `Section not found: ${o}, step: ${n}, wizard: ${r}`
      );
    return {
      id: s.id,
      component: Ke(s.component),
      props: {
        header: s.header,
        ...this.overrideSectionProps.value
      }
    };
  }
  materializeLayout(t, r) {
    const n = r.layout ?? ae;
    let o = this.repository.findLayoutById(t, n);
    if (!o && r.layout !== ae && (o = this.repository.findLayoutById(t, ae)), !o)
      throw new Error(
        `Layout not found: ${n}, wizard: ${r.id}`
      );
    return {
      id: o.id,
      component: Ke(o.component),
      stepped: o.stepped,
      props: {}
    };
  }
  steps(t, r) {
    if (t.applyMode === "full")
      return r.full?.steps || [];
    if (t.applyMode === "prescreen")
      return r.prescreen?.steps || [];
    if (t.applyMode === "prequalify")
      return r.prequalify?.steps || [];
    throw new Error(`Unknown apply mode: ${t.applyMode}`);
  }
}
const Kn = {
  phone: "(###) ###-####",
  ssn: "#########",
  ssnHidden: "!*!*!*-!*!*-####"
}, Se = /* @__PURE__ */ Symbol("fieldController"), dr = () => {
  const e = Xe(), t = et(e);
  return ne(Se, t), t;
}, Xe = () => W(Se, null), _n = () => W(Se, et, !0), et = (e) => new ur(e), bn = (e) => {
  const t = Xe(), r = i(() => ({
    id: e.id
  }));
  return t?.attach(r.value), k(r, (n, o) => {
    o && t?.detach(o.id), n && t?.attach(n);
  }), ye(() => {
    t?.detach(r.value?.id);
  }), r;
}, Ae = /* @__PURE__ */ Symbol(
  "formWizardController"
), Nn = (e) => {
  const t = dr(), r = fr(t, e);
  return ne(Ae, r), r;
}, Tn = () => W(Ae, null), Mn = () => {
  const e = W(Ae);
  if (!e)
    throw new Error("FormWizardController not found");
  return e;
}, fr = (e, t) => new pr(e, t), Dn = (e, t, r) => {
  const n = r?.modelKey ?? "modelValue", o = Fe(e, n), s = g(o.value);
  return k(o, (a) => {
    a !== s.value && (s.value = a);
  }), k(s, (a) => {
    a !== o.value && t.emit("update:modelValue", a);
  }), r?.init && (s.value = r.init()), {
    originalValue: o,
    internalValue: s
  };
}, Ce = () => {
  const e = de();
  return i(() => e.theme);
}, On = (e) => {
  const t = e?.applyMode ? g(e.applyMode) : me(), r = e?.experience ? g(e.experience) : B(), n = e?.flow ? g(e.flow) : we(), o = e?.group ? g(e.group) : Pe(), s = e?.provider ? g(e.provider) : N(), a = j(), u = e?.theme ? g(e.theme) : Ce();
  return i(() => ({
    applyMode: t.value,
    experience: r.value,
    flow: n.value,
    group: o.value,
    provider: s.value,
    route: a,
    theme: u.value
  }));
};
function Fn(e) {
  const t = Pe(), r = i(() => e.group ?? t.value), n = Ce(), o = i(() => e.theme ?? n.value);
  return $e(async () => {
    if (o.value)
      try {
        return (await e.importTheme(o.value)).default;
      } catch {
      }
    if (r.value)
      try {
        return (await e.importGroup(r.value)).default;
      } catch {
        return null;
      }
    return null;
  });
}
function $n(e, t) {
  const r = Pe(), n = i(() => t.group ?? r.value), o = Ce(), s = i(() => t.theme ?? o.value), a = N(), u = i(() => e.value ? ue(e.value) : a.value ? ue(a.value) : null);
  return $e(async () => {
    const p = u.value;
    if (!p)
      return null;
    if (s.value)
      try {
        return (await t.importTheme(s.value, p)).default;
      } catch {
      }
    if (n.value)
      try {
        return (await t.importGroup(n.value, p)).default;
      } catch {
      }
    try {
      return (await t.importProvider(p)).default;
    } catch {
      return null;
    }
  });
}
function xn() {
  const e = re();
  return i(() => e.location);
}
const kn = () => {
  const e = xe(), t = re();
  return i(
    () => t.supportPhoneNumber ?? e.t("merchant.support_phone_number")
  );
}, zn = () => {
  const e = re();
  return i(() => e.logoConfig);
}, Ln = () => {
  const e = re();
  return i(() => e.splashConfig);
};
function Un() {
  const e = E();
  return i({
    get() {
      return e.openedPaymentPlan;
    },
    set(t) {
      e.openedPaymentPlan = t;
    }
  });
}
function Wn(e) {
  const t = Ve();
  return i(() => {
    let r = null;
    return typeof e.value == "string" ? r = e.value : typeof e.value == "object" && (r = e.value.expireDateTime), r ? Math.max(
      0,
      yt(
        mt(/* @__PURE__ */ new Date()),
        r,
        vr(t.value)
      )
    ) : null;
  });
}
function vr(e) {
  return e === "proceed_standard";
}
const yr = (e) => {
  const t = fe();
  return i(() => t.isCallActive(e));
};
function Bn() {
  return yr("getPaymentPlans");
}
const mr = (e) => {
  const t = E(), r = N(), n = i(() => F(e ?? void 0) ?? r.value);
  return i(() => n.value ? t.findPaymentPlans(n.value) : {
    paymentPlans: []
  });
}, Vn = () => {
  const e = ht(), t = mr(), r = g(), n = async () => {
    const s = r.value;
    if (!s)
      throw new Error("Plan has not been selected");
    const a = t.value.paymentPlans.find(
      (u) => u.providerPlanCode === s
    );
    if (!a)
      throw Error(
        s + " is not a valid plan for the current provider"
      );
    await e.selectPaymentPlan(a);
  }, o = i(() => t.value.paymentPlans);
  return { model: r, items: o, commit: n };
}, Gn = () => {
  const e = A();
  return i({
    get: () => e.selectedPlan,
    set: (t) => e.selectedPlan = t
  });
}, tt = (e) => {
  const t = g(), r = It(async (n) => {
    let o = !1;
    n(() => {
      o = !0;
    });
    const s = await e();
    o || (t.value = s);
  });
  return ye(() => {
    r();
  }), i(() => t.value);
}, hr = (e, t) => {
  const r = tt(e);
  return i(() => r.value ?? t);
}, qn = (e) => {
  const t = N(), r = i(() => ee(e) || t.value), n = ve(), o = g(!0), s = g(!1);
  return [tt(async () => {
    if (!r.value)
      throw new Error("No provider value for useMerchantDisclaimerResponse");
    try {
      o.value = !0;
      const u = await n.getMerchantDisclaimerResponse(
        r.value
      );
      return u === void 0 && (s.value = !0), (u?.minPurchaseAmountCents === void 0 || u?.minInterestRate === void 0 || u?.maxPurchaseAmountCents === void 0) && (s.value = !0), u;
    } finally {
      o.value = !1;
    }
  }), o, s];
}, Jn = (e) => {
  const t = g(!1), r = g(!1), n = V("WellsFargoSDK"), o = Ot(), s = ve(), a = te(), u = Ut(), p = g(), l = gt(), d = _t(), v = Y(), w = i(() => l.value?.applicantType == O.JOINT ? v?.value?.joint : v?.value?.primary), I = async (P) => new Promise((y) => {
    if (window.WF_SDK_BOOTSTRAP != null) {
      y();
      return;
    }
    const _ = document.createElement("script");
    _.src = P, _.onload = () => {
      y();
    }, document.head.appendChild(_);
  }), K = async (P, y) => {
    r.value = !0, p.value?.hide();
    try {
      const _ = await s.postSdkResults(o.value, {
        status: P,
        applicationId: y?.application_id,
        approvalAmount: y?.credit_line,
        accountNumber: y?.credit_card_number,
        firstName: y?.first_name,
        lastName: y?.last_name,
        errorCode: y?.error_code,
        errorMessage: y?.error_message
      }), D = await a.addExternalResponse({
        ..._,
        applyMode: "full"
      });
      return await x(), d.emit("decision", D), D;
    } finally {
      r.value = !1;
    }
  };
  z(async () => {
    const P = v.value;
    if (!P)
      throw new Error("Invalid application state");
    const y = await s.launchSdkApply(o.value, {
      application: P
    });
    if (!y.sdkUrl)
      throw new Error("Unable to load Wells Fargo SDK - No SDK URL received");
    if (!y.merchantNumber)
      throw new Error(
        "Unable to load Wells Fargo SDK - No Merchant Number received"
      );
    if (!y.sdkEnvironment)
      throw new Error(
        "Unable to load Wells Fargo SDK - No SDK Environment received"
      );
    await I(y.sdkUrl);
    let D = {
      silentInit: !0,
      secureConfigurationUrl: `${s.config.baseUrl || ""}/api/v1/providers/${encodeURIComponent(
        o.value
      )}/sdk/token`,
      partnerHeaders: [
        {
          name: At,
          value: u.value
        }
      ],
      targetDivId: e.targetElementId,
      scrollingContainerId: e.scrollingContainerId,
      merchantNumber: y.merchantNumber,
      brandIdentifier: y.sdkBrandId || "lean",
      loggingEnabled: !0,
      consoleLoggingEnabled: !0,
      environment: y.sdkEnvironment,
      application_id: l.value?.applicationId,
      prefill: {
        first_name: w.value?.firstName,
        last_name: w.value?.lastName,
        email: w.value?.email,
        address_line_1: w.value?.homeAddress?.line1,
        city: w.value?.homeAddress?.city,
        state_code: w.value?.homeAddress?.state,
        postal_code: w.value?.homeAddress?.zipCode,
        mobile_phone: w.value?.mobilePhone,
        home_phone: w.value?.homePhone,
        work_phone: w.value?.workPhone,
        purchase_price: v?.value?.purchaseAmountCents ? (v.value.purchaseAmountCents / 100).toString() : void 0
      },
      callbacks: {
        general: {
          start: (f) => {
            n.info(`general.start: ${JSON.stringify(f)}`);
          },
          ready: (f) => {
            n.info(`general.ready: ${JSON.stringify(f)}`), t.value = !0, d.emit("ready");
          },
          exit: (f) => {
            n.info(`general.exit: ${JSON.stringify(f)}`);
          },
          log: (f) => {
            n.info(`general.log: ${JSON.stringify(f)}`);
          },
          error: async (f) => {
            const R = f;
            if (R.errorDescription) {
              const U = R.errorDescription.indexOf("arg");
              U > -1 && (R.errorDescription = R.errorDescription.slice(
                0,
                U
              ));
            }
            n.error(`general.error: ${JSON.stringify(R)}`), await K(S.ERROR, R);
          },
          secure_configuration_error: (f) => {
            n.error(
              `general.secure_configuration_error: ${JSON.stringify(f)}`
            );
          }
        },
        application: {
          start: (f) => {
            n.info(`application.start: ${JSON.stringify(f)}`);
          },
          start_over: (f) => {
            n.info(`application.start_over: ${JSON.stringify(f)}`);
          },
          terms_and_conditions: (f) => {
            n.info(
              `application.terms_and_conditions: ${JSON.stringify(f)}`
            ), C();
          },
          approved: async (f) => {
            n.info(`application.approved: ${JSON.stringify(f)}`), C(), await K(S.APPROVED, f);
          },
          denied: async (f) => {
            n.info(`application.denied: ${JSON.stringify(f)}`), C(), await K(S.DECLINED, f);
          },
          pending: async (f) => {
            n.info(`application.pending: ${JSON.stringify(f)}`), C(), await K(S.PENDING, f);
          },
          error: async (f) => {
            const R = f;
            if (R.errorDescription) {
              const U = R.errorDescription.indexOf("arg");
              U > -1 && (R.errorDescription = R.errorDescription.slice(
                0,
                U
              ));
            }
            n.error(`application.error: ${JSON.stringify(R)}`), C(), await K(S.ERROR, R);
          },
          recoverable_error: (f) => {
            n.error(
              `application.recoverable_error: ${JSON.stringify(f)}`
            );
          },
          approved_displayed: (f) => {
            n.info(
              `application.approved_displayed: ${JSON.stringify(f)}`
            );
          },
          completed: (f) => {
            n.info(`application.completed: ${JSON.stringify(f)}`);
          }
        }
      }
    };
    y.sdkVersion === "V3_0" ? D = {
      ...D,
      gatewayEntityId: y.gatewayEntityId,
      additionalAncestors: y.sdkAdditionalAncestors
    } : D = {
      ...D,
      sdkVersion: "2.1.latest"
    }, p.value = WF_SDK_BOOTSTRAP.initialize(D);
  });
  const C = () => {
    window.scrollTo(0, 0);
  };
  return {
    apply: () => {
      p.value && p.value.display("application");
    },
    busy: r,
    on: (P, y) => {
      d.on(P, y);
    },
    ready: t
  };
}, gr = (e, t, r) => {
  if (typeof t == "number")
    return e.go(t), Promise.resolve();
  if (t === "back")
    return e.go(-1), Promise.resolve();
  if (t === "forward")
    return e.forward(), Promise.resolve();
  let n;
  return typeof t == "string" ? n = {
    path: t,
    ...r
  } : r ? n = { ...t, ...r } : n = t, n.replace ? e.replace(n) : e.push(n);
}, Hn = () => {
  const e = wt();
  return i(() => {
    const t = window.history;
    if (!t)
      return !1;
    if (!t.state)
      return !0;
    if (!t.state.back)
      return !1;
    const r = t.state.position;
    if (r == null)
      return !0;
    const n = e.backPosition;
    return n == null ? !0 : r > n;
  });
}, jn = () => {
  const e = L();
  return (t, r) => gr(e, t, r);
}, Yn = () => L(), Qn = (e, t) => {
  const r = Le(), n = N();
  return hr(async () => {
    const o = t ?? n.value;
    if (!o)
      return [];
    try {
      const { disclosures: s } = await r.getDisclosures(
        o,
        e
      );
      return s;
    } catch (s) {
      return console.error(
        `Error Retrieving Disclosures for provider [${o}]` + (e ? ` and type [${e}]` : "") + ":",
        s
      ), [];
    }
  }, []);
}, Zn = (e, t, r) => {
  const n = Fe(e, t);
  return i(() => n.value || r.value);
}, Xn = () => {
  const e = Ue(), t = Xt(), r = we(), n = V("useSendVerificationCode");
  return async (o, s) => {
    try {
      const a = await e.sendVerificationCode(
        o,
        s
      );
      return r.value === "apply" && (o.email && t("primary.email", o.email), o.mobilePhone && t("primary.mobilePhone", o.mobilePhone)), a;
    } catch (a) {
      return n.error(
        `Error sending verification code for provider ${s}: `,
        a
      ), {
        status: "error"
      };
    }
  };
}, eo = () => {
  const e = Ue(), t = V("useVerifyVerificationCode");
  return async (r, n) => {
    try {
      return await e.verifyVerificationCode(
        r,
        n
      );
    } catch (o) {
      return t.error(
        `Error verifying verification code for provider ${n}: `,
        o
      ), {
        status: Ct.ERROR
      };
    }
  };
};
export {
  _r as ApplicationField,
  ur as FieldController,
  pr as FormWizardController,
  Ze as FormWizardRepository,
  Kn as MaskHelpers,
  tt as asyncComputed,
  hr as asyncComputedWithDefault,
  Zr as buildApplyResponseRouteLocation,
  Qr as buildApplyStageRoutePath,
  qe as buildProviderRouteLocation,
  Ge as buildProviderRoutePath,
  He as getApplyModeFromOperation,
  Jt as getApplyStageFromOperation,
  dr as hostFieldController,
  Nn as hostFormWizard,
  Xr as isAmbiguousResponseCode,
  gr as navigate,
  Ht as navigateByApplyResponse,
  Vt as navigateByApplyStage,
  ge as navigateByProvider,
  xr as overrideCurrentProvider,
  yn as providePageTitle,
  Ot as requireCurrentProvider,
  $r as requireCurrentProviderConfig,
  Zn as toRefWithDefault,
  no as useAcceptOffer,
  Mr as useAccountService,
  Sn as useApiError,
  br as useApplicantIncome,
  Nr as useApplicantName,
  Y as useApplication,
  oo as useApplicationService,
  Dt as useApplicationValue,
  me as useApplyMode,
  ze as useApplyResponses,
  ke as useApplyStage,
  Or as useApplyTermsContent,
  Tr as useApprovedResponses,
  hn as useAsync,
  rr as useAsyncOperation,
  mn as useAutoDetectPageTitle,
  Hn as useCanGoBack,
  We as useCascadeProviders,
  Fr as useCompleteApplication,
  vn as useComponentRef,
  N as useCurrentProvider,
  Ve as useCurrentProviderKey,
  Ft as useCurrentlySubmittableProviderConfigs,
  kr as useCurrentlySubmittableProviderModules,
  ar as useCustomStartFlow,
  zr as useDefineProviderRoute,
  Qn as useDisclosures,
  nr as useEnvironmentName,
  Cn as useExitFlow,
  B as useExperienceType,
  bn as useField,
  _n as useFieldController,
  so as useFlowService,
  Gr as useFlowSessionId,
  we as useFlowType,
  Mn as useFormWizardController,
  wn as useGlobalEventListener,
  Dr as useGoogleTagManager,
  Pe as useGroupId,
  Lr as useHasMultipleProviders,
  Ur as useIsAtHome,
  gn as useIsContentDownloadSupported,
  Wr as useIsInStore,
  Hr as useIsInitialApplicationForm,
  Pn as useIsNonProd,
  or as useIsProd,
  Br as useIsSessionActive,
  jr as useJointEnabled,
  Yr as useJointSelectionEnabled,
  On as useLocalizationContext,
  Fn as useLocalizedImporter,
  $n as useLocalizedProviderImporter,
  io as useLogger,
  Yn as useLogicalRouter,
  qn as useMerchantDisclaimerResponse,
  ao as useMerchantLegalName,
  xn as useMerchantLocation,
  zn as useMerchantLogo,
  uo as useMerchantName,
  Ln as useMerchantSplash,
  kn as useMerchantSupportPhoneNumber,
  Dn as useModel,
  en as useNavigateByApplyResponse,
  Gt as useNavigateByApplyStage,
  qr as useNavigateByProvider,
  jn as useNavigation,
  mo as useOmniApplyApiClient,
  Un as useOpenedPaymentPlan,
  Xe as useOptionalFieldController,
  Tn as useOptionalFormWizardController,
  tn as useOriginalApplication,
  rn as usePatchApplication,
  lo as usePaymentPlanService,
  mr as usePaymentPlans,
  Wn as usePlanExpirationDays,
  Bn as usePlansLoading,
  jt as usePrequalifyResponses,
  an as usePreviousManuallySubmittedProviderResponse,
  sn as usePreviousManuallySubmittedProviderResponses,
  Bt as usePrimaryProvider,
  on as usePrimaryProviderApplyMode,
  nn as useProviderDownPaymentAmount,
  Wt as useProviderModule,
  un as useRefreshPendingStipulation,
  In as useResumeApplyFlow,
  Vn as useSelectablePaymentPlans,
  Gn as useSelectedPlan,
  Xn as useSendVerificationCode,
  ln as useSessionStipulations,
  Vr as useSessionTimeout,
  tr as useSetPageTitle,
  fn as useShowEmploymentInfo,
  cn as useShowMultiLenderReviewCheckbox,
  Rn as useStartFlow,
  co as useStipulationService,
  po as useSubmitApplication,
  Jr as useSwitchableProvider,
  Le as useTermsService,
  fo as useTestCaseService,
  En as useTestCases,
  Ce as useThemeId,
  Xt as useUpdateApplicationValue,
  dn as useUpdateApplicationValues,
  An as useUserFriendlyError,
  pn as useValidateBankCard,
  vo as useValidationService,
  Ue as useVerificationService,
  eo as useVerifyVerificationCode,
  Ut as useWebSessionId,
  Jn as useWellsFargoSdk
};
//# sourceMappingURL=index.es.js.map
